import * as React from "react";
const SvgCarretUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.9999 8.40039L18.0249 14.4004L5.9749 14.4004L11.9999 8.40039Z", fill: "#757575" }));
export default SvgCarretUp;
